const homeContentFaqsEndpoints = {
  base: "/v1/cms/home-content/faqs",
  byId: (id) => `/v1/cms/home-content/faqs/${id}`,
};

export default homeContentFaqsEndpoints;
